var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    width: 42,
    height: 42,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7619 16.0528C32.7619 16.0528 32.5275 14.2116 31.8057 13.4031C30.8916 12.339 29.8697 12.3338 29.401 12.2712C26.0447 12 21.0057 12 21.0057 12H20.9963C20.9963 12 15.9572 12 12.601 12.2712C12.1322 12.3338 11.1104 12.339 10.1963 13.4031C9.47441 14.2116 9.24473 16.0528 9.24473 16.0528C9.24473 16.0528 9.00098 18.2174 9.00098 20.3768V22.4006C9.00098 24.56 9.24004 26.7246 9.24004 26.7246C9.24004 26.7246 9.47441 28.5658 10.1916 29.3743C11.1057 30.4384 12.3057 30.4018 12.84 30.5166C14.7619 30.72 21.001 30.7826 21.001 30.7826C21.001 30.7826 26.0447 30.7722 29.401 30.5062C29.8697 30.4436 30.8916 30.4384 31.8057 29.3743C32.5275 28.5658 32.7619 26.7246 32.7619 26.7246C32.7619 26.7246 33.001 24.5652 33.001 22.4006V20.3768C33.001 18.2174 32.7619 16.0528 32.7619 16.0528ZM18.5213 24.8573V17.3516L25.0041 21.1175L18.5213 24.8573Z",
    fill: "#262627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.06bad6a1750f1b9ffa80ece661e34994.svg";
export { ForwardRef as ReactComponent };